import React from 'react'

function PageLoader({ loading }) {
  return (
    <div className={`pageLoader ${!loading ? 'hidden' : ''}`}>
        <div className='logo'>
            <div className="custom-loader"></div>
        </div>
    </div>
  )
}

export default PageLoader